import React from "react";
import { DataFormControl } from "../DataFormControl";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { BooleanDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { PropertyEditorBoolean } from "../../../CommonUI/PropertyEditing/PropertyEditorBoolean";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { UISwitch } from "../../../CommonUI/BuildlingBlocks/UISwitch";
import { Box } from "@mui/material";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";

class XSwitchEditUI extends React.Component<{ editMe: SwitchFormControl }> {
    render() {
        return (
            <UISpacedBoxContent>
                {this.props.editMe.renderBaseDataControlEditor(["requiredOnAllOutcomes"])}

                <PropertyEditorBoolean
                    editObject={this.props.editMe}
                    propertyName={"defaultValue"}
                    label="Default Value"
                />
            </UISpacedBoxContent>
        );
    }
}

export class SwitchFormControl extends DataFormControl {
    readonly __type: string = "Switch";
    defaultValue: boolean = false;

    render() {
        return (
            <Box
                display={"flex"}
                alignItems={"center"}
            >
                <UILabel paddingRight={"10px"}>{this.label}</UILabel>
                <UISwitch
                    value={this.getValue()}
                    onChange={this.handleChange}
                    data-testid={this.valueName}
                />
            </Box>
        );
    }

    renderEditUI(): JSX.Element | null {
        return <XSwitchEditUI editMe={this} />;
    }

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        if (!this.valueName) return;

        let def = new BooleanDataDefinition();
        def.name = this.valueName;
        return def;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(this, retData, "__type", "defaultValue");

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(this, data, "__type", "defaultValue");
    }

    private handleChange = (newValue: boolean) => {
        if (this.valueName) {
            this.setFormDataValue(this.valueName, newValue);
        }
    };

    private getValue = () => {
        if (this.valueName) {
            let value = this.getFormDataValue(this.valueName);
            if (typeof value === "undefined" || value === null) {
                return this.defaultValue;
            }
            return value;
        }
        return this.defaultValue;
    };
}
